import React from 'react';
import styled from 'styled-components';
import AboutSection from './AboutSection';

function About(props) {
  return (
    <Wrapper>
      <AboutSection />
    </Wrapper>
  );
}

const Wrapper = styled.div`
  padding-top: var(--topNavBarHeight);

  & .title-container {
    padding: 40px 0px;
    text-align: center;

    & > h2 {
      font-size: 1.25rem;
      color: var(--primaryColor);
    }

    & > h3 {
      font-size: 1rem;
      color: var(--primaryColor);
    }

    @media screen and (max-width: 500px) {
      padding: 20px 0px;

      & > h2 {
        font-size: 1rem;
      }

      & > h3 {
        font-size: 0.75rem;
      }
    }
  }
`;

export default About;
